import { useEffect, useRef } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useStaffApplications } from 'api/auth'
import {
  APPLICATION_DETAIL_MANAGER_VIEW,
  APPLICATION_DETAIL_VIEW_PARAM,
  applicationDetailPath,
  isApplicationManagerDetailPath,
} from 'utils/applicationRoutes'

/** Redirect legacy ?view=manager and location state to /applications/manager/:publicId. */
const ApplicationDetailViewMigration = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { publicId = '' } = useParams()
  const [ searchParams ] = useSearchParams()
  const canManageApplications = useStaffApplications()
  const migratedRef = useRef(false)

  useEffect(() => {
    if (migratedRef.current || !canManageApplications || !publicId) {
      return
    }

    const onManagerPath = isApplicationManagerDetailPath(location.pathname)
    const legacyQuery = searchParams.get(APPLICATION_DETAIL_VIEW_PARAM) === APPLICATION_DETAIL_MANAGER_VIEW
    const legacyState = (location.state as ApplicationDetailLocationState | null)?.applicationsManagerView === true
    const wantsManager = legacyQuery || legacyState

    if (!wantsManager) {
      migratedRef.current = true
      return
    }

    migratedRef.current = true
    const targetPath = applicationDetailPath({ publicId, managerView: true })

    if (!onManagerPath) {
      navigate(targetPath, { replace: true })
      return
    }

    if (legacyQuery) {
      const next = new URLSearchParams(searchParams)
      next.delete(APPLICATION_DETAIL_VIEW_PARAM)
      const search = next.toString()
      navigate({ pathname: targetPath, search: search ? `?${search}` : '' }, { replace: true })
    }
  }, [
    canManageApplications,
    publicId,
    location.pathname,
    location.state,
    searchParams,
    navigate,
  ])

  return null
}

export default ApplicationDetailViewMigration
